package org.example.project.enginemodule

import org.example.project.service.ZustandManager
import org.example.project.utils.All

fun deriveSysModuleState(module: ShopModuleMeta): ModuleState =
    if (module.globalState == ZustandManager.Modul.State.AKTIVIERT) {
        if (module.updateAvailable) ModuleStateVal.UPDATE_AVAILABLE else ModuleStateVal.INSTALLED
    } else {
        ModuleStateVal.DISABLED
    }

fun createSysModule(nextId: Int): All =
    All(
        modulId = nextId,
        modulName = "",
        modulBeschreibung = "",
        modulReferenz = "0.0.0",
        modulTyp = "",
        modulAktiv = false,
        updateAvailable = false,
        modulScreens = emptyMap(),
        zustand = ZustandManager.Modul.State.DEAKTIVIERT
    ).normalizeScreens()

fun buildSysModuleStateChange(existing: All, nextState: Int): All = All(
    modulId = existing.modulId,
    modulName = existing.modulName,
    modulBeschreibung = existing.modulBeschreibung,
    modulReferenz = existing.modulReferenz,
    modulTyp = existing.modulTyp,
    modulAktiv = nextState == ZustandManager.Modul.State.AKTIVIERT,
    moduleGalleryAssetIds = existing.moduleGalleryAssetIds,
    modulKategorie = existing.modulKategorie,
    updateAvailable = existing.updateAvailable,
    modulScreens = existing.modulScreens,
    zustand = if (nextState == ZustandManager.Modul.State.AKTIVIERT) ZustandManager.Modul.State.AKTIVIERT else ZustandManager.Modul.State.DEAKTIVIERT
)

